import {RootState} from "@/store";
import {Module} from "vuex";
import PermissionService from "@/services/permissions/PermissionService";
import UserService from "@/services/users/UserService";
import {NavigationMenuItem} from "@/services/permissions/entities/NavigationMenuItem";

export interface PermissionsState {
    permissionsList: string[]
    navigationMenu: NavigationMenuItem[]
    isLoadingPermissions: boolean
}

const permissions: Module<PermissionsState, RootState> = {
    namespaced: true,
    state: {
        permissionsList: [],
        navigationMenu: [],
        isLoadingPermissions: false
    },
    mutations: {
        SET_PERMISSIONS(state, newPermissions: string[]) {
            state.permissionsList = newPermissions;
        },
        SET_NAVIGATION_MENU(state, newMenu: NavigationMenuItem[]) {
            state.navigationMenu = newMenu;
        },
        SET_LOADING_PERMISSIONS(state, isLoading: boolean) {
            state.isLoadingPermissions = isLoading;
        }
    },
    getters: {
        getNavigationMenu(state): NavigationMenuItem[] {
            return state.navigationMenu;
        },
        getPermissionsList(state): string[] {
            return state.permissionsList;
        }
    },
    actions: {
        async getPermissionsList({commit}) {
            commit('SET_LOADING_PERMISSIONS', true);
            try {
                const response = await UserService.getSessionPermissions();
                commit('SET_PERMISSIONS', response);
            } finally {
                commit('SET_LOADING_PERMISSIONS', false);
            }
        },
        async getNavigationMenu({commit}) {
            commit('SET_LOADING_PERMISSIONS', true);
            try {
                const response = await PermissionService.getNavigationMenu();
                commit('SET_NAVIGATION_MENU', response);
            } finally {
                commit('SET_LOADING_PERMISSIONS', false);
            }
        }
    }
}

export default permissions